import { UseMutationOptions, UseQueryOptions, useMutation, useQuery } from '@tanstack/react-query';
import queryString from 'query-string';

import api from '.';
import { GetCoursesRequestDto } from '../dtos/requests/get-courses.request.dto';
import { BaseResponseDto } from '../dtos/responses/base.response.dto';
import { EmptyResponseDto } from '../dtos/responses/empty.response.dto';
import { GetCourseByCodeResponseDto } from '../dtos/responses/get-course-by-code.response.dto';
import { GetCourseResponseDto } from '../dtos/responses/get-course.response.dto';
import { GetCoursesResponseDto } from '../dtos/responses/get-courses.response.dto';

const getCourseByCode = (accessCode: string) => {
  return api<BaseResponseDto<GetCourseByCodeResponseDto>, Error>(
    `/student/course/code/${accessCode}`,
    {
      method: 'GET',
    },
  );
};

export const useGetCourseByCode = (
  accessCode: string,
  options?: Omit<UseQueryOptions<BaseResponseDto<GetCourseByCodeResponseDto>, Error>, 'queryFn'>,
) => {
  return useQuery({
    queryKey: ['student', 'course', accessCode],
    queryFn: () => getCourseByCode(accessCode),
    ...options,
  });
};

const joinCourseByCode = (accessCode: string): Promise<BaseResponseDto<EmptyResponseDto>> => {
  return api<BaseResponseDto<EmptyResponseDto>, string>(`/student/course/code/${accessCode}`, {
    method: 'POST',
  });
};

/**
 *
 * @param options
 * @returns
 */
export const useJoinCourseByCode = (
  options?: Omit<
    UseMutationOptions<BaseResponseDto<EmptyResponseDto>, unknown, string>,
    'mutationFn'
  >,
) => {
  return useMutation<BaseResponseDto<EmptyResponseDto>, unknown, string>({
    mutationFn: joinCourseByCode,
    ...options, // 전달받은 옵션을 병합
  });
};

const getCourses = (params: GetCoursesRequestDto) => {
  return api<BaseResponseDto<GetCoursesResponseDto[]>, Error>(
    `/student/course?${queryString.stringify(params)}`,
    {
      method: 'GET',
    },
  );
};

export const useGetCourses = (
  params: GetCoursesRequestDto,
  options?: Omit<UseQueryOptions<BaseResponseDto<GetCoursesResponseDto[]>, Error>, 'queryFn'>,
) => {
  return useQuery({
    queryKey: ['student', 'course', params],
    queryFn: () => getCourses(params),
    ...options,
  });
};

const getCourse = (courseId: string) => {
  return api<BaseResponseDto<GetCourseResponseDto>, Error>(`/student/course/${courseId}`, {
    method: 'GET',
  });
};

export const useGetCourse = (
  courseId: string,
  options?: Omit<UseQueryOptions<BaseResponseDto<GetCourseResponseDto>, Error>, 'queryFn'>,
) => {
  return useQuery({
    queryKey: ['student', 'course', courseId],
    queryFn: () => getCourse(courseId),
    ...options,
  });
};
